import axios from "axios";
import { API_HOST } from "../main";

export default {
  getAll: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_HOST}/api/v1/categories/`)
        .then(response => resolve(response.data))
        .catch(e => reject(e));
    });
  }
};
